import { render, staticRenderFns } from "./HomeDashboard.vue?vue&type=template&id=506e8282&"
import script from "./HomeDashboard.vue?vue&type=script&lang=js&"
export * from "./HomeDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports